import invoiceDataResource from "../resources/invoiceDataResource";
import InvoiceDataItem from "../domain/invoiceData";

export default {
  async findByFilter (filter) {
    let response = await invoiceDataResource.query(
      _.pickBy({
        dateFrom: filter.dateFrom.format('YYYY-MM-DD'),
        dateTo: filter.dateTo.format('YYYY-MM-DD'),
        customerId: filter.customerId
      }, _.identity));
    if (response.ok) {
      return new InvoiceDataItem(response.data);
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./client/services/invoiceDataService.js